import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Header, Select, Table, Form, Button, Loader } from 'semantic-ui-react';
import { defectData } from '../../app/models/Restoration';
import { useStore } from '../../app/stores/store';
import { toast } from 'react-toastify';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import DynamicTableCSVReport from '../DynamicTable/DynamicTableCSVReport';

const QualityHistory = () => {
  const { RestorationStore, PivotStore } = useStore();
  const [reportTypeValue, setReportTypeValue] = useState<string>('Report Type');
  const [tableEnable, SetTableEnable] = useState<boolean>(false);
  const [tableLoading,setTableLoading]=useState<boolean>(true);
  const [assingTitleCode, setAssignTitleCode] = useState<
    { key: string; text: string; value: string }[]
  >([]);

  const [loadData, setLoadData] = useState<defectData[]>([]);
  const [reportType, setReportType] = useState<string>('');
  const reportTypeOptions = [
    { key: 1, text: 'Title Wise', value: 'Title Wise' },
    { key: 2, text: 'Date Wise', value: 'Date Wise' },
  ];
  let reportName = '';
  const currentDate = new Date();
  const [startDate, setStartDate] = useState(() => {
    return moment(currentDate).format('MM-DD-YYYY');
  });
  const [endDate, setendDate] = useState(() => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${month}-${day}-${year}`;
  });

  useEffect(() => {
    RestorationStore.getTitleCode();
    // eslint-disable-next-line
  }, []);

  const reportTypeAssign = async (event: any, data: any) => {
    const { value } = data;
    let reportType = reportTypeOptions.find((option) => option.value === value);
    if (reportType) {
      setReportTypeValue(reportType.value);
      if (reportType.value === 'Title Wise') {
        setReportType('Title Wise');
      } else if (reportType.value === 'Date Wise') {
        setReportType('Date Wise');
        setLoadData([]);
      } else {
        setReportType('');
        SetTableEnable(false);
        setLoadData([]);
      }
    } else {
      setReportTypeValue('Report Type');
      SetTableEnable(false);
      setLoadData([]);
      setReportType('');
    }
  };
  const titleBasedDataLoad = async (titlename: string) => {
    try {
      if (!titlename) {
        setLoadData([]);
        setTableLoading(false);
        return;
      }
      setTableLoading(true);
      setLoadData([]);
      await RestorationStore.titleWiseDefectReport(titlename);
      setLoadData(RestorationStore.responseForDefectData);
      SetTableEnable(true);
      setTableLoading(false);
      reportName = 'Defect_Report' + titlename;
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
      SetTableEnable(false);
      setTableLoading(false);
    }
  };

  const dateBasedDataLoad = async () => {
    try {
      setTableLoading(true);
      setLoadData([]);
      await RestorationStore.dateWiseDefectReport(startDate, endDate);
      setLoadData(RestorationStore.responseForDefectData);
      SetTableEnable(true);
      setTableLoading(false);
      reportName = 'Defect_Report_From_' + startDate + '_upto_' + endDate;
    } catch (error) {
      toast.error('Something went wrong. Please try again !');
      SetTableEnable(false);
      setTableLoading(false);
    }
  };

  const setDate = (data: any, type: string) => {
    try {
      if (type === 'start') {
        setStartDate(moment(data).format('MM-DD-YYYY'));
      } else {
        if (type === 'end') setendDate(moment(data).format('MM-DD-YYYY'));
      }
    } catch (error) {
      toast.error('Error fetching Date');
    }
  };
  useEffect(() => {
    const loadTitleCode = RestorationStore.titleCodeData.map(
      (titleCodeList: string) => {
        return {
          key: titleCodeList,
          text: titleCodeList,
          value: titleCodeList,
        };
      },
    );
    setAssignTitleCode(loadTitleCode);
    // eslint-disable-next-line
  }, [reportTypeValue]);
  return (
    <>
      <div className="title-wise-table">
        <Header> Defect Report</Header>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h4
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingRight: '20px',
                paddingTop: '10px',
              }}
            >
              Report Type
            </h4>
            <Select
              placeholder="Report Type"
              filter
              selection
              search
              clearable
              options={reportTypeOptions}
              onChange={reportTypeAssign}
            />
            {reportType === 'Title Wise' ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h4
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    paddingRight: '20px',
                    paddingTop: '10px',
                    paddingLeft: '20px',
                  }}
                >
                  Title Code{' '}
                </h4>
                <Select
                  style={{ display: 'flex', alignItems: 'center' }}
                  placeholder="Select Title code"
                  filter
                  Selection
                  search
                  clearable
                  options={assingTitleCode}
                  onChange={(_event, data) =>
                    titleBasedDataLoad(data.value as string)
                  }
                />
                {loadData.length !== 0 && (
                  <div style={{marginLeft: '10px'}}>
                  <DynamicTableCSVReport
                    tableData={loadData}
                    tableName={reportName}
                  />
                  </div>
                )}
              </div>
            ) : reportType === 'Date Wise' ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <>
                    <h4
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: '20px',
                        paddingTop: '10px',
                      }}
                    >
                      From Date
                    </h4>
                    <DatePicker
                      placeholderText="From Date"
                      value={
                        startDate
                          ? PivotStore.dateFormat(
                              moment(startDate).format('MM-DD-YYYY'),
                            )
                          : ''
                      }
                      className="date-picker-style"
                      showMonthDropdown
                      showYearDropdown
                      locale={'en'}
                      dateFormatCalendar="MMMM"
                      yearDropdownItemNumber={15}
                      maxDate={moment().toDate()}
                      scrollableYearDropdown
                      onChange={(date: any) => setDate(date, 'start')}
                      popperProps={{ strategy: 'fixed' }}
                    />
                  </>
                </div>
                <Form.Field required={true}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <>
                      <h4
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          paddingTop: '10px',
                          paddingLeft: '20px',
                        }}
                      >
                        To Date{' '}
                      </h4>
                      <DatePicker
                        placeholderText="To Date"
                        value={
                          endDate
                            ? PivotStore.dateFormat(
                                moment(endDate).format('MM-DD-YYYY'),
                              )
                            : ''
                        }
                        className="date-picker-style"
                        showMonthDropdown
                        showYearDropdown
                        locale={'en'}
                        dateFormatCalendar="MMMM"
                        yearDropdownItemNumber={15}
                        maxDate={moment().add(0, 'days').toDate()}
                        scrollableYearDropdown
                        onChange={(date: any) => setDate(date, 'end')}
                        popperProps={{ strategy: 'fixed' }}
                      />
                    </>
                  </div>
                </Form.Field>
                <Form.Field>
                  <Button
                    primary
                    onClick={dateBasedDataLoad}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingRight: '20px',
                      paddingBottom: '10px',
                    }}
                  >
                    View Report
                  </Button>
                </Form.Field>
                {loadData.length !== 0 && (
                  <div style={{marginLeft: '10px'}}>
                  <DynamicTableCSVReport
                    tableData={loadData}
                    tableName={reportName}
                  />
                  </div>
                )}
                
              </>
            ) : null}
          </div>
        </div>
        <div>
        <br />
        {tableLoading===true && reportType!=='' &&(
                      <div>
                     <div>
                        <br/>
                        <Loader active inline='centered' > Please wait, this will take a few minutes... </Loader>
                      </div> 
                    </div>
                    )}
          {tableEnable && tableLoading===false && (
            <>
              {' '}
              <div >
                <Table className="ui fixed table" style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch',maxwidth:'60%' }}>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Reject Date</Table.HeaderCell>
                      <Table.HeaderCell>Title Code</Table.HeaderCell>
                      <Table.HeaderCell>Team</Table.HeaderCell>
                      <Table.HeaderCell>Operator Employee ID</Table.HeaderCell>
                      <Table.HeaderCell>Operator Name</Table.HeaderCell>
                      <Table.HeaderCell>Quality ID</Table.HeaderCell>
                      <Table.HeaderCell>Quality Name</Table.HeaderCell>
                      <Table.HeaderCell>Work Type</Table.HeaderCell>
                      <Table.HeaderCell>Restoration</Table.HeaderCell>
                      <Table.HeaderCell>Reel Name</Table.HeaderCell>
                      <Table.HeaderCell>Shot Name</Table.HeaderCell>
                      <Table.HeaderCell>Start Frame</Table.HeaderCell>
                      <Table.HeaderCell>End Frame</Table.HeaderCell>
                      <Table.HeaderCell>Total Frame</Table.HeaderCell>
                      <Table.HeaderCell>Defect Type</Table.HeaderCell>
                      <Table.HeaderCell>Error Start Frame</Table.HeaderCell>
                      <Table.HeaderCell>Error End Frame</Table.HeaderCell>
                      <Table.HeaderCell>Error Total Frame</Table.HeaderCell>
                      <Table.HeaderCell>Position</Table.HeaderCell>
                      <Table.HeaderCell>Severity</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    
                    {loadData.length === 0 && tableLoading===false && (
                      <Table.Row>
                        <Table.Cell colSpan={20} textAlign="center">
                          Data is currently unavailable
                        </Table.Cell>
                      </Table.Row>
                    )}
                    {loadData.length !== 0 &&
                      loadData.map((data, index) => (
                        <Table.Row key={index}>
                          <Table.Cell>{data.reject_Date}</Table.Cell>
                          <Table.Cell>{data.title_Code}</Table.Cell>
                          <Table.Cell>{data.team}</Table.Cell>
                          <Table.Cell>{data.operator_Employee_ID}</Table.Cell>
                          <Table.Cell>{data.operator_name}</Table.Cell>
                          <Table.Cell>{data.quality_ID}</Table.Cell>
                          <Table.Cell>{data.quality_name}</Table.Cell>
                          <Table.Cell>{data.work_Type}</Table.Cell>
                          <Table.Cell>{data.resolution}</Table.Cell>
                          <Table.Cell>{data.reel_Name}</Table.Cell>
                          <Table.Cell>{data.shot_Name}</Table.Cell>
                          <Table.Cell>{data.start_Frame}</Table.Cell>
                          <Table.Cell>{data.end_Frame}</Table.Cell>
                          <Table.Cell>{data.total_Frame}</Table.Cell>
                          <Table.Cell>{data.typeoferror}</Table.Cell>
                          <Table.Cell>{data.error_St_Frame}</Table.Cell>
                          <Table.Cell>{data.error_end_Frame}</Table.Cell>
                          <Table.Cell>{data.error_total_Frame}</Table.Cell> 
                          <Table.Cell>{data.position}</Table.Cell>
                          <Table.Cell>{data.severity}</Table.Cell>
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default observer(QualityHistory);
